import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";
import { CompensationCalculator } from "@/components/tools/CompensationCalculator";
import { TalentBarometer } from "@/components/tools/TalentBarometer";
import { CvAssessment } from "@/components/tools/CvAssessment";

export default function Tools() {
  return (
    <div data-testid="tools-page">
      <PageHero
        breadcrumb={[{ label: "Tools" }]}
        eyebrow="Tools & Intelligence"
        title="Data-driven tools, built from the inside."
        intro="Model compensation, read the market, or start a confidential conversation — each tool draws on the same proprietary Monaco-Geneva intelligence that powers our search work."
      />

      <section className="section-py pt-8" data-testid="calculator-section">
        <div className="container-bp">
          <SectionHeading eyebrow="Compensation Calculator" title="What does this role really pay?" intro="Indicative base, bonus and total compensation by role, seniority and market. Updates instantly." />
          <div className="mt-10"><CompensationCalculator /></div>
        </div>
      </section>

      <section className="section-py bg-[color:var(--bp-bg-2)]" data-testid="barometer-section">
        <div className="container-bp">
          <SectionHeading eyebrow="Talent Barometer" title="How the market is moving." intro="Our quarterly read on hiring velocity, compensation movement and cross-market talent flow." />
          <div className="mt-10"><TalentBarometer /></div>
        </div>
      </section>

      <section className="section-py" data-testid="cv-section">
        <div className="container-bp grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <SectionHeading eyebrow="For candidates" title="A confidential read on your market value." intro="If you're a senior banking professional, submit your CV for a discreet assessment. No obligation, complete confidentiality." />
          <Reveal><CvAssessment /></Reveal>
        </div>
      </section>

      <CTABand title="Want the intelligence behind these tools?" subtitle="Book a confidential briefing and we'll share market data specific to your roles and segments." />
    </div>
  );
}
